import { updateItems } from '@/pages/home/mocks/data';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-3">
            实时快讯
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">最新八卦快讯</h2>
          <p className="text-foreground-500 mt-2 text-sm">每分钟都有新瓜上线，不错过任何一条劲爆消息</p>
        </div>

        <div className="relative pl-8 md:pl-10 border-l-2 border-primary-200">
          {updateItems.map((item) => (
            <div key={item.id} className="relative pb-6 last:pb-0">
              <div className={`absolute -left-[25px] md:-left-[29px] w-4 h-4 rounded-full border-2 ${item.hot ? 'bg-primary-500 border-primary-500' : 'bg-background-50 border-primary-300'}`}></div>
              <div className="ml-1">
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className="text-xs text-foreground-400 font-mono">{item.date}</span>
                  <span className={`px-2 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${item.hot ? 'bg-primary-100 text-primary-700' : 'bg-background-100 text-foreground-500'}`}>
                    {item.tag}
                  </span>
                  {item.hot && (
                    <span className="inline-flex items-center gap-0.5 text-[10px] text-primary-500 font-medium">
                      <i className="ri-fire-line"></i>
                      热
                    </span>
                  )}
                </div>
                <a href="#updates" className="text-sm text-foreground-800 hover:text-primary-600 transition-colors leading-relaxed cursor-pointer">{item.title}</a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}